<template>
  <div>
    <!-- <b-loading :active.sync="isLoadingPage"></b-loading> -->
    <transition name="slide-fade">
      <div class="loading-integreat" v-if="isLoadingPage" >
          <div class="initial-load-animation" >
          <div class="linkedin-image"></div>
            <div class="loading-bar">
              <div class="blue-bar"></div>
            </div>
          </div>
      </div>
    </transition>
    <div class="level is-margin-bottom-2 is-hidden-mobile">
        <div class="column is-5">
          <p class="title pd-t-15 is-size-4-tablet is-size-5-mobile has-text-weight-normal">Department list</p>
        </div>
    </div>
    <b-tabs v-model="activeTab" size="is-large " class="tab-thai" 
    :class="{'tab-exclusive':getRule=='exclusiveboard'?true:false,'tab-board':getRule=='board'?true:false}">
      <b-tab-item label="หน่วยงานในสังกัด" class="mg-less tab-thai">
      <div class="columns is-margin-x-not head-table is-hidden-mobile" >
        <div class="column is-6 has-text-centered" @click="sortBy('name')">
          <p
            class="is-size-8 has-text-weight-semibold cr-pointer"
            :class="{'has-text-secondary':currentSort === 'name'}"
          >
            Department
            <span
              class="arrow"
              :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
              v-show="currentSort == 'name'"
            ></span>
          </p>
        </div>
        <div class="column is-2 has-text-centered" @click="sortBy('name')">
          <p
            class="is-size-8 has-text-weight-semibold cr-pointer"
            :class="{'has-text-secondary':currentSort === 'name'}"
          >
            Board
            <span
              class="arrow"
              :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
              v-show="currentSort == 'name'"
            ></span>
          </p>
        </div>
        <div class="column is-3 has-text-centered" @click="sortBy('name')">
          <p
            class="is-size-8 has-text-weight-semibold cr-pointer"
            :class="{'has-text-secondary':currentSort === 'name'}"
          >
            Admin
            <span
              class="arrow"
              :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
              v-show="currentSort == 'name'"
            ></span>
          </p>
        </div>
      </div>
      <div
        class="columns detail-table is-margin-x-not is-vcentered "
        :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}"
        v-for="(data,index) in scienceParkBoard"
        :key="index"
      >
        <div class="column is-6" data-label="name">
          <div
            v-if="widthMax > 768"
            class="is-align-center is-justify-center is-flex-large is-flex-row is-hidden-mobile"
          >
            <div class="column is-2 is-2-fullhd has-text-centered-tablet has-text-right">
              <figure class="image is-marginless">
                <img class="" v-if="data.logo" :src="imgUrlSC+data.logo" @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'">
                <img
                  class="is-rounded"
                  v-else
                  src="https://bulma.io/images/placeholders/64x64.png"
                  alt="Placeholder image"
                >
              </figure>
            </div>
            <div class="column is-9">
              <p class="is-size-7 th">{{data.name}}</p>
            </div>
          </div>
          <div class="column is-5 has-text-right pd-col-fixed is-hidden-tablet">
             <b-dropdown position="is-bottom-left">
                <button class="button dp-btn-noBg" slot="trigger">
                  <template>
                    <b-tooltip label="More" position="is-bottom" type="is-white" 
                      :delay="500">
                      <b-icon
                        pack="fas"
                        icon="sync-alt"
                        custom-class="fa-ellipsis-v label-right"
                        class="has-text-grey-light is-margin-right-m"
                      ></b-icon>
                    </b-tooltip>
                  </template>
                </button>
                <b-dropdown-item
                  @click="openModal(data.boards)" class="is-align-center has-border-black is-justify-center is-flex-medium is-flex-row dp-item-normal " :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}" >
                  <div class="">
                    <p class="textActive">Board detail</p>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="openModalAdmin(data.admins)" class="is-align-center has-border-black is-margin-top-s is-justify-center is-flex-medium is-flex-row dp-item-normal " :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}" >
                  <div class="">
                    <p class="textActive">Admin detail</p>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToAdmin(data._id,'in')"
                  class="is-align-center has-border-black is-justify-center is-flex-medium is-flex-row is-margin-top-s dp-item-normal"
                  :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}"
                  >
                  <p class="">Admin lists</p>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          <div
            v-if="widthMax < 768"
            class="is-align-center is-justify-center is-flex is-flex-column is-hidden-tablet"
          >
            

            <div class="column is-5 has-text-centered pd-col-fixed">
              <figure class="image box-logo-l">
                <img class="is-rounded" v-if="data.logo" :src="imgUrlSC+data.logo" @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'">
                <img
                  v-else
                  src="https://bulma.io/images/placeholders/64x64.png"
                  alt="Placeholder image"
                >
              </figure>
            </div>
            <div class="column is-1 has-text-centered pd-col-fixed">
              <p class="is-size-7 th">{{data.name}}</p>
            </div>
          </div>
        </div>
        <div v-if="typeof data.boards != 'undefined'" class="column is-2 has-text-centered th" data-label="updatedAt">
          {{data.boards.length}} ผู้บริหาร
        </div>
        <div v-if="typeof data.admins != 'undefined'" class="column is-3 has-text-centered th" data-label="updatedAt">
          {{data.admins.length}} ผู้ดูแล
        </div>
        <div class="column is-1 has-text-right dp-menu-action is-hidden-mobile">
          <b-dropdown position="is-bottom-left">
            <button class="button dp-btn-noBg" slot="trigger">
              <template>
                <b-tooltip label="More" position="is-bottom" type="is-white" :delay="500">
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-ellipsis-v label-right"
                    class="has-text-grey-light is-margin-right-m"
                  ></b-icon>
                </b-tooltip>
              </template>
            </button>
            <b-dropdown-item
              @click="openModal(data.boards)" class="is-align-center has-border-black is-justify-center is-flex-medium is-flex-row dp-item-normal " :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}" >
              <div class="">
                <p class="textActive">Board detail</p>
              </div>
            </b-dropdown-item>
            <b-dropdown-item
              @click="openModalAdmin(data.admins)" class="is-align-center has-border-black is-margin-top-s is-justify-center is-flex-medium is-flex-row dp-item-normal " :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}" >
              <div class="">
                <p class="textActive">Admin detail</p>
              </div>
            </b-dropdown-item>
            <b-dropdown-item
              @click="goToAdmin(data._id,'in')"
              class="is-align-center has-border-black is-justify-center is-flex-medium is-flex-row is-margin-top-s dp-item-normal"
              :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}"
              >
              <p class="">Admin lists</p>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </b-tab-item>
     <b-tab-item label="หน่วยงานนอกสังกัด" class="mg-less tab-thai">
      <div class="columns is-margin-x-not head-table is-hidden-mobile" >
        <div class="column is-8 has-text-centered" @click="sortBy('name')">
          <p
            class="is-size-7 has-text-weight-semibold cr-pointer"
            :class="{'has-text-secondary':currentSort === 'name'}"
          >
            Admin
            <span
              class="arrow"
              :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
              v-show="currentSort == 'name'"
            ></span>
          </p>
        </div>
        <div class="column is-3 has-text-centered" @click="sortBy('name')">
          <p
            class="is-size-7 has-text-weight-semibold cr-pointer"
            :class="{'has-text-secondary':currentSort === 'name'}"
          >
            Projects
            <span
              class="arrow"
              :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
              v-show="currentSort == 'name'"
            ></span>
          </p>
        </div>
      </div>
      <div v-if="typeof adminData !== 'undefined' && adminData.length == 0 " class="is-detail-list detail-table mg-y-15">
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">***</p>
      <p
        class="has-text-drak is-size-6 th is-padding-x has-text-centered"
      >ขณะนี้ยังไม่มีเจ้าหน้าที่</p>
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">***</p>
    </div>

    <div
      class=""
      v-for="(data,index) in adminData"
      :key="index"
      v-else
    >
      <b-collapse :open="false" :aria-id="'contentIdForA11y'+index" class=" detail-table mg-b-35"
      >
        <div  
          slot="trigger" 
              slot-scope="props"
              role="button"
              class="columns is-margin-x-not is-vcentered m-h-auto  box " 
              :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}"
              :aria-controls="'contentIdForA11y'+index"
              >
            <div class="column is-8 is-paddingless" data-label="name">
              <div
                v-if="widthMax > 768"
                class="is-align-center is-justify-center is-flex-large is-flex-row is-hidden-mobile"
              >
                <div class="column is-1">
                  <div class="mg-x-10">
                    <div class="border-radius" :class="{'active':props.open,'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}" v-show="props.open">
                      <b-icon
                        pack="fas" 
                                :icon="'angle-down'">
                            </b-icon>
                    </div>
                    <div class="border-radius" v-show="props.open == false">
                            <b-icon 
                        pack="fas" 
                                icon="angle-up">
                            </b-icon>
                        </div>
                  </div>
                </div>
                <div class="column is-2 is-2-fullhd has-text-centered-tablet has-text-right">
                  <figure class="image box-circle-logo is-marginless">
                    <img class="is-rounded" v-if="data.profile" :src="imgUrl+data.profile" @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'">
                    <img
                      class=""
                      v-else
                      src="https://bulma.io/images/placeholders/64x64.png"
                      alt="Placeholder image"
                    >
                  </figure>
                </div>
                <div class="column is-8 has-text-centered">
                  <p class="is-size-6 th">{{data.organizeName}}</p>
                  <p class="is-size-7 th">{{data.name}} {{data.surname}}</p>
                </div>
              </div>
              <div class="column is-5 has-text-right pd-col-fixed is-hidden-tablet">
               <b-dropdown position="is-bottom-left">
                  <button class="button dp-btn-noBg" slot="trigger">
                    <template>
                      <b-tooltip label="More" position="is-bottom" type="is-white" :delay="500">
                        <b-icon
                          pack="fas"
                          icon="sync-alt"
                          custom-class="fa-ellipsis-v label-right"
                          class="has-text-grey-light is-margin-right-m"
                        ></b-icon>
                      </b-tooltip>
                    </template>
                  </button>
                  <b-dropdown-item
                    @click="openModal(data.boards)" class="is-align-center has-border-black is-justify-center is-flex-medium is-flex-row dp-item-normal " :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}" >
                    <div class="">
                      <p class="textActive">Board detail</p>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="openModalAdmin(data.admins)" class="is-align-center has-border-black is-margin-top-s is-justify-center is-flex-medium is-flex-row dp-item-normal " :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}" >
                    <div class="">
                      <p class="textActive">Admin detail</p>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToAdmin(data._id,'in')"
                    class="is-align-center has-border-black is-justify-center is-flex-medium is-flex-row is-margin-top-s dp-item-normal"
                    :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}"
                    >
                    <p class="">Admin lists</p>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div
                v-if="widthMax < 768"
                class="is-align-center is-justify-center is-flex is-flex-column is-hidden-tablet"
              >
                <div class="column is-5 has-text-centered pd-col-fixed">
                  <figure class="image box-circle-s">
                   <img class="is-rounded" v-if="data.profile" :src="imgUrl+data.profile" @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'">
                    <img
                      class="is-rounded"
                      v-else
                      src="https://bulma.io/images/placeholders/64x64.png"
                      alt="Placeholder image"
                    >
                  </figure>
                </div>
                <div class="column is-1 has-text-centered pd-col-fixed">
                  <p class="is-size-6 th">{{data.organizeName}}</p>
                  <p class="is-size-7 th">{{data.name}} {{data.surname}}</p>
                </div>
              </div>
            </div>
            <div v-if="typeof data.batchs !== 'undefined'" class="column is-3 is-paddingless has-text-centered th" data-label="Batch">
            {{data.batchs.length}} โครงการ
            </div>
        </div>
        <div class="card-content" v-if="data.batchs.length > 0 && data.batchs !== 'undefined'">
          <div>
            <div class="columns m-h-auto mg-b-20 has-text-centered has-text-grey-light th">
              <div class="column is-4">
                <p>ชื่อโครงการ</p>
              </div>
            </div>
          </div>
          <div v-for="(item,key) in data.batchs" :key="key">
            <div class="columns m-h-auto has-text-centered th is-size-6">
              <div class="column is-4 is-paddingless">
                <p>{{item.name}}</p>
              </div>
              <div class="column is-paddingless is-flex is-align-center is-justify-end cr-pointer">
                <span @click="viewDashboard(item,data.adminId)" class="mg-r-20 is-flex is-align-center is-justify-end">
                  <b-icon
                      pack="fas" 
                      icon="eye">
                  </b-icon> View
                </span>
              </div>
            </div>
                  <hr/>
              </div>
            </div>
      </b-collapse>
        </div>
    </b-tab-item>
  </b-tabs>
   
  <b-modal :active.sync="isModal" :width="800" @close="closeModal()">
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <div v-if="typeof staffLists !== 'undefined'" class="has-text-left">
              <h1 class="is-size-4 th">Board {{staffLists.length}} ผู้บริหาร</h1>
            </div>
          	<div v-for="(data,index) in staffLists" class="columns m-h-auto" v-if="typeof staffLists !== 'undefined' && staffLists.length > 0">
          		<div class="width-max">
                <div class="is-justify-center is-align-center is-flex is-flex-column box-border width-max is-padding-y">
                  <figure class="image box-circle-profile is-margin-top-m">
                    <img class="is-rounded" v-if="data.profilePic" :src="imgUrl + data.profilePic" @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'">
                    <img
                      class="is-rounded"
                      v-else
                      src="https://bulma.io/images/placeholders/128x128.png"
                      alt="Placeholder image"
                    >
                  </figure> 
                  <p class="is-size-5 has-text-weight-semibold pd-l-10 is-margin-top width-max label-left">
                    Personal information
                    <span class="th">(ข้อมูลส่วนตัว)</span>
                  </p>
                  <hr class="width-95-per is-margin-y-s mg-b-10">
                  <div class="width-max">
                    <div class="has-text-left is-padding-left-l is-margin-top-m">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-pen has-color-board"></i>
                        Name: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.titleName}} {{data.name}}</span>
                      </p>
                      <p v-if="widthMax < 768"><span class="fw-300 confirm-text-color confirm-padding-left th">{{data.titleName}} {{data.name}}</span></p>
                    </div>
                    <div class="has-text-left is-padding-left-l is-margin-top-m ">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-pen has-color-board"></i>
                        Last Name: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.surname}}</span>
                      </p>
                      <p class="w-break-all"><span v-if="widthMax < 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.surname}}</span></p>
                    </div>
                    <div class="has-text-left is-padding-left-l is-margin-top-m ">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-user has-color-board"></i>
                        Position: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.position}}</span>
                      </p>
                      <p class="w-break-all"><span v-if="widthMax < 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.position}}</span></p>
                    </div>
                     <div class="has-text-left is-padding-left-l is-margin-top-m ">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-phone has-color-board"></i>
                        Telephone number: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.mobilePhone}}</span>
                      </p>
                      <p class="w-break-all"><span v-if="widthMax < 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.mobilePhone}}</span></p>
                    </div>
                    <div class="has-text-left is-padding-left-l is-margin-top-m ">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-envelope has-color-board"></i>
                        E-mail: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.email}}</span>
                      </p>
                      <p class="w-break-all"><span v-if="widthMax < 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.email}}</span></p>
                    </div>
                  </div>
                </div>
              </div>
          	</div>
            <div v-else class="has-text-centered pd-20">
              *** ยังไม่มีเจ้าหน้าที่ ***
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isModalAdmin" :width="800" @close="closeModal()">
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <div v-if="typeof staffLists !== 'undefined'" class="has-text-left">
              <h1 class="is-size-4 th">Admin {{adminList.length}} ผู้ดูแล</h1>
            </div>
            <div v-for="(data,index) in adminList" class="columns m-h-auto" v-if="typeof adminList !== 'undefined' && adminList.length > 0">
              <div class="width-max">
                <div class="is-justify-center is-align-center is-flex is-flex-column box-border width-max is-padding-y">
                  <figure class="image box-circle-profile is-margin-top-m">
                    <img class="is-rounded" v-if="data.profilePic" :src="imgUrl + data.profilePic" @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'">
                    <img
                      class="is-rounded"
                      v-else
                      src="https://bulma.io/images/placeholders/128x128.png"
                      alt="Placeholder image"
                    >
                  </figure> 
                  <p class="is-size-5 has-text-weight-semibold pd-l-10 is-margin-top width-max label-left">
                    Personal information
                    <span class="th">(ข้อมูลส่วนตัว)</span>
                  </p>
                  <hr class="width-95-per is-margin-y-s mg-b-10">
                  <div class="width-max">
                    <div class="has-text-left is-padding-left-l is-margin-top-m">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-pen has-color-board"></i>
                        Name: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.titleName}} {{data.name}}</span>
                      </p>
                      <p v-if="widthMax < 768"><span class="fw-300 confirm-text-color confirm-padding-left th">{{data.titleName}} {{data.name}}</span></p>
                    </div>
                    <div class="has-text-left is-padding-left-l is-margin-top-m ">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-pen has-color-board"></i>
                        Last Name: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.surname}}</span>
                      </p>
                      <p class="w-break-all"><span v-if="widthMax < 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.surname}}</span></p>
                    </div>
                    <div class="has-text-left is-padding-left-l is-margin-top-m ">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-user has-color-board"></i>
                        Position: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.position}}</span>
                      </p>
                      <p class="w-break-all"><span v-if="widthMax < 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.position}}</span></p>
                    </div>
                     <div class="has-text-left is-padding-left-l is-margin-top-m ">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-phone has-color-board"></i>
                        Telephone number: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.mobilePhone}}</span>
                      </p>
                      <p class="w-break-all"><span v-if="widthMax < 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.mobilePhone}}</span></p>
                    </div>
                    <div class="has-text-left is-padding-left-l is-margin-top-m ">
                      <p class="is-size-6 has-text-weight-semibold">
                        <i class="fas fa-lg fa-envelope has-color-board"></i>
                        E-mail: <span v-if="widthMax > 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.email}}</span>
                      </p>
                      <p class="w-break-all"><span v-if="widthMax < 768" class="fw-300 confirm-text-color confirm-padding-left th">{{data.email}}</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="has-text-centered pd-20">
              *** ยังไม่มีเจ้าหน้าที่ ***
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../axios.js"

	export default{
		data(){
			return{
        activeTab:0,
        isModalAdmin:false,
				isModal:false,
        adminList:[],
				staffLists:[],
				widthMax: window.innerWidth,
				imgUrl: process.env.VUE_APP_IMAGE_URL,
        imgUrlSC: process.env.VUE_APP_IMAGE_URL_sciencePark,
				isLoadingPage: null,
				currentSort: "",
				currentSortDir: "asc",
				dataSciencePark:[],
				boardData:[],
				scienceParkBoard:[],
        personList:[],
        adminData:[]
			}
		},
		async created(){
      await this.fetchData()
			await this.getSciencePark()
      this.fetchDataAdmin()
		},
		mounted() {
			this.isLoadingPage = true;
		},
		computed:{
			user(){
				return this.$store.state.user
			},
			getRule() {
        return this.$store.getters.getRule;
      },
			token() {
		      return this.$store.state.token;
		  }
		},
		methods:{
      closeModal(){
        this.$store.commit("setModalActive", false)
      },
			getScienceParkName(value){
				let data = this.dataSciencePark.filter(search =>{
					return search._id == value
				})
				if(data.length > 0){
					return data[0].name
				}else{
					return ''
				}
			},
			async getSciencePark(){
	      await HTTP.post('/get/all/science/park',{underId:this.user.under}).then(res =>{
	        this.dataSciencePark = res.data.obj
	      })
        this.isLoadingPage = false;
	    },
      viewDashboard(batchId,adminId){
        this.$store.commit("setDataBatch", batchId);
        let data ={
          key:'adminId',
          value:adminId
        }
        this.$store.commit('setReportId',data)
        this.$router.push('/board-view-dashboard')
      },
			openModal(value){
        this.staffLists = value
        this.$store.commit("setModalActive", true);
        this.isModal = true
			},
      openModalAdmin(value){
        this.adminList = value
        this.$store.commit("setModalActive", true);
        this.isModalAdmin = true
      },
			goToAdmin(value,view){
	      let data =[{
		        key:'scienceParkId',
		        value:value
		      },{
            key:'viewAdmin',
            value:view
          }
        ]
	      //console.log('goToAdmin',data)
        data.map(item=>{
          this.$store.commit('setReportId',item)
        })
	      this.$router.push('/department-admin-list')
		  },
			async fetchData() {
		       HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;

					let data = {
						url:'/get/all/science/park',
						underId:this.user.under
					}
  		    await HTTP.post(data.url,data).then(res => {
             this.dataSciencePark = res.data.obj
  	        	//console.log('/get/all/science/park',res)
              if(this.getRule == 'board'){
                let dataBoard = res.data.obj.filter(search =>{
                    return search._id == this.user.scienceParkId
                })

                if(dataBoard.length > 0){
                    this.scienceParkBoard = dataBoard
                }
              }else{
                this.scienceParkBoard = res.data.obj
              }
              //console.log('this.scienceParkBoard ',this.scienceParkBoard )
              this.isLoadingPage = false; 	
  			  }).catch(e => {
          this.isLoadingPage = false;
          console.log("api/user/get/staff/on/batch/error", e);
          alert("เครือขายไม่เสถียร กรุณาลองใหม่");
        });
		    },
        fetchDataAdmin(){
          HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
          let dataSend
          if(this.getRule == 'board'){
            dataSend = {
              scienceParkId:this.user.scienceParkId,
              underId:this.user.under,
            }
           
          }else{
            dataSend = {
              underId:this.user.under
            }
          
          }
          //console.log(data)
          HTTP.post(`/api/get/all/admin`,dataSend).then(res => {
            //console.log('/api/get/all/admin',res)
            //this.adminData = res.data.obj.adminNotUnder
            let data =[]
            let checkId = []
            res.data.obj.adminNotUnder.map(value=>{
              if(data.length > 0){
                checkId = data.filter(search =>{
                  return value.adminId == search.adminId
                })
              }
              //console.log('checkId',checkId)
              if(checkId.length == 0){
                let filter = res.data.obj.adminNotUnder.filter(search =>{
                  return value.adminId == search.adminId
                })
                //console.log('filter',filter)
                if(filter.length > 0){
                  filter.map((admin,index) =>{
                    //console.log('admin',admin)
                    if(index == 0){
                      data.push(admin)
                    }else{
                      data[0].batchs.push(admin.batchs[0])
                    }
                    //console.log('data1',data)     
                  })
                }
              }
               checkId = []
            }) 
            //console.log('data2',data) 
            this.adminData =   data
          })
          this.isLoadingPage = false;
      }
		}
	}
</script>
<style >
.dp-item-normal.hover-border-board:hover{
  background-color: #fff!important;
  border: 1px solid #00B2FF!important;
}
.dp-item-normal.hover-border:hover{
  background-color: #fff!important;
  border: 1px solid #FFB82E!important;
}
.border-radius.active.hover-border-board{
    background-color: #00B2FF;
    border:1px solid #00B2FF;
    color: #fff;
  }
.border-radius.active.hover-border{
  background-color: #FFB82E;
  border:1px solid #FFB82E;
  color: #fff;
}
.border-radius.active .icon{
  color: #fff;
}
.tab-exclusive li.is-active a{
  border-bottom-color: #FFB82E!important;
}

.tab-board li.is-active a{
  border-bottom-color: #00B2FF !important;
}
  .mg-less{
    margin:0 -1rem!important;
  }
  .border-radius{
      display: flex;
      border-radius: 50%;
      align-items: center;
      width: 28px;
      justify-content: center;
      color: #e1e1e1;
      border: 2px solid #e1e1e1;
  }
  .has-color-board{
    color:#016299!important;
  }
</style>